import styles from './Listing.module.less';
import { Description, Title } from './ListingParts';

export const PublicConsultation = ({ item, isEditMode }) => {
  return (
    <div className={styles.body}>
      <Title item={item} isEditMode={isEditMode} />
      {item?.data_inicio && (
        <div>
          <span>Data de Inicio da Consulta: </span>
          <span>{item?.data_inicio || '-'}</span>
        </div>
      )}

      {item?.data_fim && (
        <div>
          <span>Data Final da Consulta: </span>
          <span>{item?.data_fim || '-'}</span>
        </div>
      )}
      <Description item={item} hideDatePublished className="mt-2" />
    </div>
  );
};
